var radioBtnData = {
  name: "radioButton",
  data: [{
    fontFamily: "MicrosoftYaHei",
    fontSize: 12,
    fontColor: "#5a6677",
    radius: 11.5,
    btnHeight: 22,
    btnPadding: "0 8px",
    btnMarginRight: 16,
    btnBoxShadow: "none",
    borderColor: "#3889FF",
    checkedFontColor: "white",
    checkedBorderColor: "#3889FF",
    checkedBgColor: "#3889FF",
    disabledFontColor: "#AAADBA",
    disabledBorderColor: "#E7EAED",
    disabledBgColor: " #F8F8F8"
  }]
};
export default radioBtnData;